
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { TransportationDetails } from '@/types/itinerary';
import TransportationForm from '../TransportationForm';

interface JourneyCardContentProps {
  isAuthorized: boolean;
  details: TransportationDetails;
  handleChange: (field: string, value: any) => void;
  saveDetails: () => void;
  formTitle: string;
  saveButtonText: string;
}

const JourneyCardContent: React.FC<JourneyCardContentProps> = ({ 
  isAuthorized,
  details,
  handleChange,
  saveDetails,
  formTitle,
  saveButtonText
}) => {
  return (
    <CardContent>
      {isAuthorized ? (
        <TransportationForm
          details={details}
          onChange={handleChange}
          onSave={saveDetails}
          formTitle={formTitle}
          saveButtonText={saveButtonText}
        />
      ) : (
        <div className="mt-4 text-center">
          <p className="text-muted-foreground">
            Only trip members can manage travel details
          </p>
        </div>
      )}
    </CardContent>
  );
};

export default JourneyCardContent;
